import script from "./ProsemirrorEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProsemirrorEditor.vue?vue&type=script&lang=ts&setup=true"

import "./ProsemirrorEditor.vue?vue&type=style&index=0&id=76d3203e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76d3203e"]])

export default __exports__